module.exports = __webpack_public_path__ + "img/gbwhata-download.3c769aa8.webp";